// extracted by mini-css-extract-plugin
export default {"box":"SliderNote_box__18Jnf","positionLeft":"SliderNote_positionLeft__7Xc3i","positionRight":"SliderNote_positionRight__nVXSW","btn":"SliderNote_btn__4q-Tl"};